import { SavingsAccountsProvider } from './../savings-accounts/savings-accounts';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { GatewayClientProvider } from '../gateway-client/gateway-client';


@Injectable()
export class SavingsAnalysisProvider {

  transactions: any = [];
  goal_achieve_status: string = "Your Goal"
  constructor(
    public savingsAccountsProvider: SavingsAccountsProvider,
    public gateway: GatewayClientProvider,
    public http: Http) {


  }

  getAnalysis(customer_accounts) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getsavinganalyis(customer_accounts)
        .then((data: any) => {
          resolve(data);
        }).catch((err) => {
          // console.error(err);
          reject(err);
        })
    })
  }


  getGoalAnalysis(account: any, goalamount: any, balanceamt: any, goalname: string) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.savingsAccountsProvider.getTransactions(account).then((data: any) => {
        resolve(self.filterTransactionsbySixMonths(data, balanceamt, goalamount, goalname));
      }).catch((err) => {
        // console.error(err);
        reject(err);
      })
    })
  }

  filterTransactionsbySixMonths(data, balanceamt, goalamount, goalname) {
    var total_amt_6 = 0; var total_amt_3 = 0; var total_amt_1 = 0;
    for (let i of data.cleared) {
      var transaction_date = new Date(i.date); //your input date here

      var todaysDate_6 = new Date(); // today date
      todaysDate_6.setMonth(todaysDate_6.getMonth() - 6);  //subtract 6 month from current date 
      if (transaction_date > todaysDate_6) {
        total_amt_6 += parseFloat(i.amount);

      }
      var todaysDate_3 = new Date(); // today date
      todaysDate_3.setMonth(todaysDate_3.getMonth() - 3);  //subtract 3 month from current date 
      if (transaction_date > todaysDate_6) {
        total_amt_3 += parseFloat(i.amount);

      }
      var todaysDate_1 = new Date(); // today date
      todaysDate_1.setMonth(todaysDate_1.getMonth() - 1);  //subtract 1 month from current date 
      if (transaction_date > todaysDate_1) {
        total_amt_1 += parseFloat(i.amount);

      }
    }

    let avg_deposit_amgt: any = (balanceamt - total_amt_6) / 6;



    if (avg_deposit_amgt < 0) {
      avg_deposit_amgt = (balanceamt - total_amt_3) / 3;


      if (avg_deposit_amgt < 0) {
        avg_deposit_amgt = (balanceamt - total_amt_1);


        if (avg_deposit_amgt < 0) {
          return "Based on your current savings pattern you will be not able to buy your " + goalname + " - try saving more";
        }
        else {
          let bal_amt = goalamount - balanceamt;
          let noofdays = bal_amt / avg_deposit_amgt;
          return this.checkMonthOfCompletion(noofdays, goalname);
        }
      }
      else {
        let bal_amt = goalamount - balanceamt;
        let noofdays = bal_amt / avg_deposit_amgt;
        return this.checkMonthOfCompletion(noofdays, goalname);
      }
    }
    else {
      let bal_amt = goalamount - balanceamt;
      let noofdays = bal_amt / avg_deposit_amgt;
      return this.checkMonthOfCompletion(noofdays, goalname);
    }
  }

  checkMonthOfCompletion(goalDays, goalname) {
    if (goalDays < 1) {
      return "Based on your current savings pattern, you will be able to buy " + goalname + " in this Months - Keep saving !";
    }
    else {
      return "Based on your current savings pattern, you will be able to buy " + goalname + " in " + Math.round(goalDays) + " Months - Keep saving !"
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/savings-analysis/savings-analysis.ts